(function () {
  'use strict';

  angular
      .module('tf.retailer.Util')
      .directive('setChartLayout', SetChartLayout);

  // @ngInject
  function SetChartLayout($timeout) {
    return {
      restrict: 'A',
      scope: {
        setChartLayout: '='
      },
      link: function(scope, element, attrs) {
        scope.$watchCollection('setChartLayout', function (value) {
          if (scope.$parent.$last){
            $timeout(function(){
              var childElemWidthArr = [];
              var elem = document.getElementsByClassName(element[0].className);
              var elemWidth = elem[0].clientWidth;
              var elemCounts = elem.length;
              var childCounts = element[0].childElementCount;
              var margin = 30 + 40*(childCounts-1);
              var remainingWidth = elemWidth - margin;
              for(var i=0;i<childCounts;i++){
                var maxWidth = 0;
                for(var j=0;j<elemCounts;j++){
                  if(maxWidth < elem[j].children[i].offsetWidth){
                    maxWidth = elem[j].children[i].offsetWidth;
                  }
                }
                var columnClassName = elem[0].children[i].classList[1];
                childElemWidthArr.push({columnName: columnClassName, columnWidth: maxWidth});
              }
              var childWidthDivSum = _.reduce(_.map(_.filter(childElemWidthArr, function(o){
                return o.columnName != 'style-name';
              }), 'columnWidth'), function(memo, num){
                return memo + num}, 0);
              var styleNameColWidth = remainingWidth - childWidthDivSum;
              var caretWidth = 5;
              for(var i=0;i<childCounts;i++){
                //IE9 and above doesn't support NodeList which query selector returns. Need to convert from nodeList to Array
                var divs = Array.prototype.slice.call(document.querySelectorAll('.' + elem[0].children[i].classList[1]), 0);
                document.querySelectorAll('.'+ elem[0].children[i].classList[1])[0].style.width = '';
                var firstDivWidth = document.querySelectorAll('.' + elem[0].children[i].classList[1])[0].offsetWidth;
                divs.forEach(function(res) {
                  if (firstDivWidth > childElemWidthArr[i].columnWidth){
                    res.style.width = (firstDivWidth + caretWidth) + 'px';
                  }else{
                    if(res.classList[1] === 'style-name'){
                      if(childElemWidthArr[i].columnWidth > styleNameColWidth){
                        res.style.width = styleNameColWidth + 'px';
                      }else{
                        res.style.width = (childElemWidthArr[i].columnWidth + 2) + 'px';
                      }
                    }else{
                      res.style.width = childElemWidthArr[i].columnWidth + 'px';
                    }
                  }
                });
              }
            }, 0, false);
          }
        });
      }
    }
  }

})();
